import { Divider } from "@mui/material";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { Link } from "react-router-dom";

import BankResetAnnouncement from "web/Layout/BankResetAnnouncement";
import ErrorBoundary from "web/Layout/ErrorBoundary";
import MessagesTrigger from "web/Layout/MainHeader/Shared/MessagesTrigger";
import SearchAutocomplete from "web/Layout/SearchAutocomplete";
import __ from "web/Layout/Translations";

import urls from "web/constants/urls";

import CartTrigger from "../CartTrigger";
import MBHeader from "../MBHeader";
import MainMenu from "../MainMenu";
import mainMenuItemClasses from "../MainMenu/MainMenuItem/mainMenuItem.scss";
import WishlistTrigger from "../WishlistTrigger";
import classes from "./mainHeaderDashboard.scss";

interface IMainHeaderDashboardProps {
  shouldShowMessage: boolean;
}

const MainHeaderDashboard: FC<IMainHeaderDashboardProps> = ({
  shouldShowMessage,
}) => {
  return (
    <div className={classes.root}>
      <MBHeader />
      <div className={classes.header}>
        <div className={`containerDashboard ${classes.headerRow}`}>
          <div className={classes.heading}>
            <Link to={urls.home} className={mainMenuItemClasses.link}>
              <Typography variant="subtitle1" sx={{ py: "11px" }}>
                {__("Kafeteria")}
              </Typography>
            </Link>
            <Divider orientation="vertical" flexItem sx={{ pl: 3 }} />
          </div>
          <div className={classes.headerUI}>
            <ErrorBoundary smallTextSize>
              <SearchAutocomplete className={classes.search} />
            </ErrorBoundary>
            <ul className={classes.list}>
              <li className={classes.item}>
                <ErrorBoundary smallTextSize>
                  <MessagesTrigger />
                </ErrorBoundary>
              </li>
              <li className={classes.item}>
                <ErrorBoundary smallTextSize>
                  <WishlistTrigger />
                </ErrorBoundary>
              </li>
              <li className={classes.item}>
                <ErrorBoundary smallTextSize>
                  <CartTrigger />
                </ErrorBoundary>
              </li>
            </ul>
          </div>
        </div>

        <ErrorBoundary smallTextSize>
          <MainMenu />
        </ErrorBoundary>
      </div>
      <BankResetAnnouncement shouldShowMessage={shouldShowMessage} />
    </div>
  );
};

export default MainHeaderDashboard;
